<template>
  <div>
    <v-card class="pa-3">
      <h1>Promotion Item(s)</h1>
      <template v-if="promotionType === 'ซื้อสินค้าคู่กัน'">
        <v-layout wrap>
          <v-flex xs12 class="form-control py-2" :class="{ 'has-error': errors.has('valueType1') }">
            <div class="pb-1">สินค้าที่ 1 <span class="red--text">*</span></div>
            <div class="pb-2">
              <v-radio-group
                v-model="input.type_1"
                color="primary"
                row
                class="text-xs-center mt-0"
                name="type1"
                hide-details
              >
                <v-radio color="primary" label="สินค้า" :value="'product'"></v-radio>
                <v-radio color="primary" label="Marketing" :value="'mkt'"></v-radio>
                <v-radio color="primary" label="Sub Marketing" :value="'submkt'"></v-radio>
              </v-radio-group>
            </div>
            <div>
              <v-autocomplete
                id="valueType1"
                v-model="input.value_type_1"
                v-validate="'required'"
                name="valueType1"
                data-vv-as="ตัวเลือก"
                flat
                solo
                outline
                :items="type1Options"
                hide-details
                class="default-input-textfield"
              ></v-autocomplete>

              <p v-if="errors.has('valueType1')" class="text-error">
                {{ errors.first('valueType1') }}
              </p>
            </div>
          </v-flex>
          <v-flex xs12 class="form-control py-2" :class="{ 'has-error': errors.has('valueType2') }">
            <div class="pb-1">สินค้าที่ 2 <span class="red--text">*</span></div>
            <div class="pb-2">
              <v-radio-group
                v-model="input.type_2"
                color="primary"
                row
                class="text-xs-center mt-0"
                name="type2"
                hide-details
              >
                <v-radio color="primary" label="สินค้า" :value="'product'"></v-radio>
                <v-radio color="primary" label="Marketing" :value="'mkt'"></v-radio>
                <v-radio color="primary" label="Sub Marketing" :value="'submkt'"></v-radio>
              </v-radio-group>
            </div>
            <div>
              <v-autocomplete
                id="valueType2"
                v-model="input.value_type_2"
                v-validate="'required'"
                name="valueType2"
                data-vv-as="ตัวเลือก"
                flat
                solo
                outline
                :items="type2Options"
                hide-details
                class="default-input-textfield"
              ></v-autocomplete>

              <p v-if="errors.has('valueType2')" class="text-error">
                {{ errors.first('valueType2') }}
              </p>
            </div>
          </v-flex>

          <v-flex
            xs12
            class="form-control pb-2"
            :class="{ 'has-error': errors.has('increasedType') }"
          >
            <div class="pt-1">
              <v-radio-group
                v-model="input.increased_type"
                color="primary"
                row
                class="text-xs-center"
                name="increasedType"
                hide-details
              >
                <v-radio color="primary" label="รับคะแนนเพิ่ม" :value="'plus'"></v-radio>
                <v-radio color="primary" label="คูณคะแนน" :value="'multiply'"></v-radio>
              </v-radio-group>
              <p v-if="errors.has('increasedType')" class="text-error">
                {{ errors.first('increasedType') }}
              </p>
            </div>
          </v-flex>
          <v-flex xs12 class="form-control pb-2" :class="{ 'has-error': errors.has('increased') }">
            <v-text-field
              v-model="input.increased"
              v-validate="'required'"
              flat
              outline
              solo
              :placeholder="'จำนวน'"
              name="increased"
              class="default-input-textfield"
              :data-vv-as="'จำนวน'"
              hide-details
            ></v-text-field>
            <p v-if="errors.has('increased')" class="text-error">
              {{ errors.first('increased') }}
            </p>
          </v-flex>
        </v-layout>
      </template>
      <template v-else>
        <v-layout wrap>
          <v-flex xs12 class="form-control py-2" :class="{ 'has-error': errors.has('valueType1') }">
            <div class="pb-2">
              <v-radio-group
                v-model="input.purchase_type_1"
                color="primary"
                row
                class="text-xs-center mt-0"
                name="type1"
                hide-details
              >
                <v-radio color="primary" label="สินค้า" :value="'product'"></v-radio>
                <v-radio color="primary" label="Marketing" :value="'mkt'"></v-radio>
                <v-radio color="primary" label="Sub Marketing" :value="'submkt'"></v-radio>
              </v-radio-group>
            </div>
            <div>
              <v-autocomplete
                id="valueType1"
                v-model="input.purchase_value_type_1"
                v-validate="'required'"
                name="valueType1"
                data-vv-as="ตัวเลือก"
                flat
                solo
                outline
                :items="typeOptions"
                hide-details
                class="default-input-textfield"
              ></v-autocomplete>

              <p v-if="errors.has('valueType1')" class="text-error">
                {{ errors.first('valueType1') }}
              </p>
            </div>
          </v-flex>
          <v-flex xs12 class="form-control pb-2" :class="{ 'has-error': errors.has('Type2') }">
            <v-radio-group
              v-model="input.purchase_type_2"
              color="primary"
              row
              class="text-xs-center"
              name="Type2"
              hide-details
            >
              <v-radio color="primary" label="ซื้อครบจำนวนชิ้น" :value="'item'"></v-radio>
              <v-radio color="primary" label="ซื้อมูลค่าตั้งแต่" :value="'price'"></v-radio>
            </v-radio-group>
            <p v-if="errors.has('Type2')" class="text-error">
              {{ errors.first('Type2') }}
            </p>
          </v-flex>
          <v-flex xs12 class="form-control" :class="{ 'has-error': errors.has('valueType2') }">
            <v-text-field
              v-model="input.purchase_value_type_2"
              v-validate="'required'"
              flat
              outline
              solo
              :placeholder="'จำนวน'"
              name="valueType2"
              class="default-input-textfield"
              :data-vv-as="'จำนวน'"
              hide-details
            ></v-text-field>
            <p v-if="errors.has('valueType2')" class="text-error pt-2">
              {{ errors.first('valueType2') }}
            </p>
          </v-flex>

          <v-flex
            xs12
            class="form-control pb-2"
            :class="{ 'has-error': errors.has('increasedType') }"
          >
            <div class="pt-1">
              <v-radio-group
                v-model="input.purchase_increased_type"
                color="primary"
                row
                class="text-xs-center"
                name="increasedType"
                hide-details
              >
                <v-radio color="primary" label="รับคะแนนเพิ่ม" :value="'plus'"></v-radio>
                <v-radio color="primary" label="คูณคะแนน" :value="'multiply'"></v-radio>
              </v-radio-group>
              <p v-if="errors.has('increasedType')" class="text-error">
                {{ errors.first('increasedType') }}
              </p>
            </div>
          </v-flex>
          <v-flex xs12 class="form-control pb-2" :class="{ 'has-error': errors.has('increased') }">
            <v-text-field
              v-model="input.purchase_increased"
              v-validate="'required'"
              flat
              outline
              solo
              :placeholder="'จำนวน'"
              name="increased"
              class="default-input-textfield"
              :data-vv-as="'จำนวน'"
              hide-details
            ></v-text-field>
            <p v-if="errors.has('increased')" class="text-error">
              {{ errors.first('increased') }}
            </p>
          </v-flex>
        </v-layout>
      </template>

      <div xs12 class="pt-3 text-xs-center">
        <v-btn outline color="grey" @click="handleClose">{{ $t('cancel') }}</v-btn>
        <v-btn color="primary" depressed @click="handleSaveData">{{ $t('Save') }}</v-btn>
      </div>
    </v-card>
  </div>
</template>

<script>
import toaCrmApi from '@/api/toa-crm'
import DatepickerCustomDialog from '@/components/elements/DatepickerCustomDialog.vue'
import { mapGetters } from 'vuex'
import moment from 'moment'

export default {
  props: ['value', 'promotionType', 'formType', 'promotionId'],
  data() {
    return {
      input: {
        type_1: 'product',
        value_type_1: '',
        type_2: 'product',
        value_type_2: '',
        increased_type: 'plus',
        increased: '',
        purchase_type_1: 'product',
        purchase_value_type_1: '',
        purchase_type_2: 'item',
        purchase_value_type_2: '',
        purchase_increased_type: 'plus',
        purchase_increased: ''
      }
    }
  },
  async mounted() {
    if (this.value) {
      if (this.promotionType === 'ซื้อสินค้าคู่กัน') {
        this.input.increased = this.value.increased
        this.input.increased_type = this.value.increased_type
        this.input.type_1 = this.value.type_1
        this.input.type_2 = this.value.type_2

        if (this.value.type_1 === 'product') {
          this.input.value_type_1 = this.value.product_id_1
        } else if (this.value.type_1 === 'mkt') {
          this.input.value_type_1 = this.value.mkt_id_1
        } else if (this.value.type_1 === 'submkt') {
          this.input.value_type_1 = this.value.sub_mkt_id_1
        }

        if (this.value.type_2 === 'product') {
          this.input.value_type_2 = this.value.product_id_2
        } else if (this.value.type_2 === 'mkt') {
          this.input.value_type_2 = this.value.mkt_id_2
        } else if (this.value.type_2 === 'submkt') {
          this.input.value_type_2 = this.value.sub_mkt_id_2
        }
      } else {
        this.input.purchase_increased = this.value.increased
        this.input.purchase_increased_type = this.value.increased_type
        this.input.purchase_type_1 = this.value.type
        this.input.purchase_type_2 = this.value.price_type
        this.input.purchase_value_type_2 = this.value.price_from

        if (this.value.type === 'product') {
          this.input.purchase_value_type_1 = this.value.product_id
        } else if (this.value.type === 'mkt') {
          this.input.purchase_value_type_1 = this.value.mkt_id
        } else if (this.value.type === 'submkt') {
          this.input.purchase_value_type_1 = this.value.sub_mkt_id
        }
      }
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    moment() {
      return moment
    },
    typeOptions() {
      let options = []
      if (this.input.purchase_type_1 === 'product') {
        options = this.productName
      } else if (this.input.purchase_type_1 === 'mkt') {
        options = this.productMarketing
      } else if (this.input.purchase_type_1 === 'submkt') {
        options = this.productSubMarketing
      }

      return options
    },
    type1Options() {
      let options = []
      if (this.input.type_1 === 'product') {
        options = this.productName
      } else if (this.input.type_1 === 'mkt') {
        options = this.productMarketing
      } else if (this.input.type_1 === 'submkt') {
        options = this.productSubMarketing
      }

      return options
    },
    type2Options() {
      let options = []
      if (this.input.type_2 === 'product') {
        options = this.productName
      } else if (this.input.type_2 === 'mkt') {
        console.log('xx')
        options = this.productMarketing
      } else if (this.input.type_2 === 'submkt') {
        options = this.productSubMarketing
      }

      return options
    },
    productName() {
      return this.$store.state.toacrmProductName
    },
    productMarketing() {
      return this.$store.state.toacrmProductMarketing
    },
    productSubMarketing() {
      return this.$store.state.toacrmProductSubMarketing
    }
  },
  methods: {
    async handleSaveData() {
      const vm = this
      try {
        const result = await this.$validator.validateAll()

        if (!result) {
          this.goToErrorInput()
          return false
        }

        let data = null
        let response = null
        vm.$store.dispatch('loading')
        if (vm.promotionType === 'ซื้อสินค้าคู่กัน') {
          data = {
            type_1: vm.input.type_1,
            type_2: vm.input.type_2,
            increased_type: vm.input.increased_type,
            increased: vm.input.increased
          }

          const valueType1 = vm.input.value_type_1
          if (vm.input.type_1 === 'product') {
            Object.assign(data, { product_id_1: valueType1 })
          } else if (vm.input.type_1 === 'mkt') {
            Object.assign(data, { mkt_id_1: valueType1 })
          } else if (vm.input.type_1 === 'submkt') {
            Object.assign(data, { sub_mkt_id_1: valueType1 })
          }

          const valueType2 = vm.input.value_type_2
          if (vm.input.type_2 === 'product') {
            Object.assign(data, { product_id_2: valueType2 })
          } else if (vm.input.type_2 === 'mkt') {
            Object.assign(data, { mkt_id_2: valueType2 })
          } else if (vm.input.type_2 === 'submkt') {
            Object.assign(data, { sub_mkt_id_2: valueType2 })
          }

          if (vm.formType === 'add') {
            response = await vm.createPromotionItemMatch(data)
          } else {
            response = await vm.updatePromotionItemMatch(data)
          }
        } else {
          data = {
            type: vm.input.purchase_type_1,
            price_type: vm.input.purchase_type_2,
            increased_type: vm.input.purchase_increased_type,
            increased: vm.input.purchase_increased,
            price_from: vm.input.purchase_value_type_2
          }

          const valueType1 = vm.input.purchase_value_type_1
          if (vm.input.purchase_type_1 === 'product') {
            Object.assign(data, { product_id: valueType1 })
          } else if (vm.input.purchase_type_1 === 'mkt') {
            Object.assign(data, { mkt_id: valueType1 })
          } else if (vm.input.purchase_type_1 === 'submkt') {
            Object.assign(data, { sub_mkt_id: valueType1 })
          }

          if (vm.formType === 'add') {
            response = await vm.createPromotionItemFullPurchase(data)
          } else {
            response = await vm.updatePromotionItemFullPurchase(data)
          }
        }

        vm.$store.dispatch('loading')
        if (response && response.status === 200) {
          vm.$emit('success')
        }
      } catch (error) {
        console.error(error)
        vm.$store.dispatch('loading')
      }
    },
    async createPromotionItemFullPurchase(payload) {
      try {
        const response = await toaCrmApi.postPromotionFullPurchaseDetail({
          data: payload,
          pageId: this.selectedBot.pageid,
          promotionId: this.promotionId
        })

        if (response) {
          return response
        } else {
          return null
        }
      } catch (error) {
        console.error(error)
        return null
      }
    },
    async updatePromotionItemFullPurchase(payload) {
      try {
        const response = await toaCrmApi.patchPromotionFullPurchaseDetail({
          data: payload,
          pageId: this.selectedBot.pageid,
          id: this.value.id
        })

        if (response) {
          return response
        } else {
          return null
        }
      } catch (error) {
        console.error(error)
        return null
      }
    },
    async createPromotionItemMatch(payload) {
      try {
        const response = await toaCrmApi.postPromotionMatchDetail({
          data: payload,
          pageId: this.selectedBot.pageid,
          promotionId: this.promotionId
        })

        if (response) {
          return response
        } else {
          return null
        }
      } catch (error) {
        this.$swal.fire({
          type: 'error',
          html: '<strong>ไม่สามารถจับคู่ระหว่างสินค้า <br/> ที่อยู่ใน MKT หรือ Sub MKT เดียวกันได้</strong>'
        })
        console.error(error)
        return null
      }
    },
    async updatePromotionItemMatch(payload) {
      try {
        const response = await toaCrmApi.patchPromotionMatchDetail({
          data: payload,
          pageId: this.selectedBot.pageid,
          id: this.value.id
        })

        if (response) {
          return response
        } else {
          return null
        }
      } catch (error) {
        this.$swal.fire({
          type: 'error',
          html: '<strong>ไม่สามารถจับคู่ระหว่างสินค้า <br/> ที่อยู่ใน MKT หรือ Sub MKT เดียวกันได้</strong>'
        })
        console.error(error)
        return null
      }
    },
    handleClose() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/toacrm/Promotion/PromotionItemsManage.vue